import React from 'react';
import { escapeRegExp } from 'lodash-es';

type HighlightedTextProps = {
  text: string;
  /** 검색어 — 매칭 부분을 파랑으로 하이라이트 */
  keyword?: string;
};

/**
 * 검색어와 일치하는 부분을 파랑(#0066cc)으로 표시.
 * 양식/인물 필터 등 검색 결과 리스트에서 공통 사용. (PORTAL-12884)
 */
const HighlightedText = ({ text, keyword }: HighlightedTextProps) => {
  if (!keyword) return <>{text}</>;
  const parts = text.split(new RegExp(`(${escapeRegExp(keyword)})`, 'gi'));
  // 조각을 그대로 내보내면 부모가 flex 컨테이너일 때 각 조각이 개별 flex item 이 되어
  // 조각 사이 공백이 사라진다(‘인테리어 OPEN 비용 정산’ → ‘인테리어OPEN비용 정산’).
  // inline 요소 하나로 감싸 부모 레이아웃과 무관하게 텍스트 흐름을 유지한다. (PORTAL-12903)
  return (
    <span>
      {parts.map((part, i) =>
        part.toLowerCase() === keyword.toLowerCase() ? (
          <span key={i} style={{ color: 'var(--dk-accent, #0066cc)' }}>
            {part}
          </span>
        ) : (
          part
        ),
      )}
    </span>
  );
};

export default HighlightedText;
